var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-upload',{ref:_vm.chunkedUpload,attrs:{"http-request":_vm.chunkedUpload,"action":_vm.uploadUrl,"data":_vm.uploadData,"on-error":_vm.onError,"before-remove":_vm.beforeRemove,"on-progress":_vm.progress,"name":"file","multiple":"","limit":3}},[_vm._v("上传")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e071aecc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/b.vue
// module id = null
// module chunks = 